module.exports = __webpack_public_path__ + "img/logo-scatbook-black.ca66ec5a.svg";